const brandMainWrap = () => import("@/views/main_wrap.vue");

const createBrandViewRoute = ({ path, name, component, aliases = [] }) => ({
    path,
    name,
    alias: aliases,
    component: brandMainWrap,
    children: [
        {
            path: "",
            component
        }
    ]
});

export const brandRoutes = [
    createBrandViewRoute({
        path: "/brand/overview",
        name: "GsrbrSmain",
        aliases: ["/gsrbr_smain", "/brand/gsrbr_smain"],
        component: () => import("@/views/brand/gsrbr_smain.vue")
    }),
    createBrandViewRoute({
        path: "/brand/gs25",
        name: "Gsrbr010101",
        aliases: ["/gsrbr010101", "/brand/gsrbr010101"],
        component: () => import("@/views/brand/01/gsrbr010101.vue")
    }),
    createBrandViewRoute({
        path: "/brand/gs-the-fresh",
        name: "Gsrbr020101",
        aliases: [
            "/gsrbr020101",
            "/brand/gsrbr020101",
            "/brand/gsrbr020102",
            "/brand/gsrbr020201",
            "/brand/gsrbr020202",
            "/brand/gsrbr0203",
            "/brand/gsrbr0204",
            "/brand/gsrbr020401"
        ],
        component: () => import("@/views/brand/02/gsrbr020101.vue")
    }),
    createBrandViewRoute({
        path: "/brand/gs-shop",
        name: "Gsrbr0301",
        aliases: ["/gsrbr0301", "/brand/gsrbr0301"],
        component: () => import("@/views/brand/03/gsrbr0301.vue")
    }),
    createBrandViewRoute({
        path: "/brand/our-neighborhood-gs",
        name: "Gsrbr04",
        aliases: [
            "/gsrbr04",
            "/brand/gsrbr04",
            "/brand/gsrbr0401",
            "/brand/gsrbr0402",
            "/brand/gsrbr0403",
            "/brand/gsrbr0404"
        ],
        component: () => import("@/views/brand/04/gsrbr04.vue")
    }),
    createBrandViewRoute({
        path: "/brand/gs-pay",
        name: "Gsrbr05",
        aliases: ["/gsrbr05", "/brand/gsrbr05"],
        component: () => import("@/views/brand/05/gsrbr05.vue")
    }),
    createBrandViewRoute({
        path: "/brand/gs-all",
        name: "Gsrbr06",
        aliases: [
            "/gsrbr06",
            "/brand/gsrbr06",
            "/brand/gsrbr0601",
            "/brand/gsrbr0602",
            "/brand/gsrbr0603"
        ],
        component: () => import("@/views/brand/06/gsrbr06.vue")
    }),
    createBrandViewRoute({
        path: "/brand/pop",
        name: "Gsrbr07",
        aliases: ["/gsrbr07", "/brand/gsrbr07"],
        component: () => import("@/views/brand/07/gsrbr07.vue")
    }),
    createBrandViewRoute({
        path: "/brand/yours",
        name: "Gsrbr08",
        aliases: ["/gsrbr08", "/brand/gsrbr08"],
        component: () => import("@/views/brand/08/gsrbr08.vue")
    }),
    createBrandViewRoute({
        path: "/brand/real-price",
        name: "Gsrbr09",
        aliases: ["/gsrbr09", "/brand/gsrbr09"],
        component: () => import("@/views/brand/09/gsrbr09.vue")
    }),
    createBrandViewRoute({
        path: "/brand/woodil",
        name: "Gsrbr10",
        aliases: ["/gsrbr10", "/brand/gsrbr10"],
        component: () => import("@/views/brand/01/gsrbr10.vue")
    }),
    createBrandViewRoute({
        path: "/brand/development-rental-business",
        name: "Gsrbr1101",
        aliases: [
            "/gsrbr1101",
            "/brand/gsrbr1101",
            "/brand/gsrbr110201",
            "/brand/gsrbr110202",
            "/brand/gsrbr110203",
            "/brand/gsrbr110204"
        ],
        component: () => import("@/views/brand/01/gsrbr1101.vue")
    }),
];
